"use client";

/**
 * The required / exclude / remove action row shared by every Talent Search
 * filter value. It lives in the shared filters kit so panels that have no
 * required/optional concept (the job pipeline) render the same chip affordances
 * minus the asterisk — pass no `onToggleRequired` there.
 */
export { FilterChipActions as FilterValueActions } from "@/components/ui/filters";
